import { Divider, AnchorButton, ButtonGroup } from '@wheely/ui-kit';
import cn from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useExternalLinks } from '@/app/hooks/useExternalLinks';
import { LanguageSwitcher } from '@src-common/view/components/LanguageSwitcher';

import s from './style.module.css';

const Footer: React.VFC = () => {
  const links = useExternalLinks();

  return (
    <div className={cn(s.footer)} data-test-id="quest-footer">
      <LanguageSwitcher className={s.languageSwitcher} />
      <Divider />

      <ButtonGroup
        minimal={true}
        square={true}
        className={s.linksGroup}
        data-test-id="quest-footer__links"
      >
        <AnchorButton href={links.termsOfUse} small={true} className={s.link}>
          <FormattedMessage
            description="Terms & Conditions link text"
            defaultMessage="Terms & Conditions"
            id="l3pPMG"
          />
        </AnchorButton>
        <AnchorButton href={links.privacyPolicy} small={true} className={s.link}>
          <FormattedMessage
            description="Privacy Policy link text"
            defaultMessage="Privacy Policy"
            id="C3ZF7Z"
          />
        </AnchorButton>
        <AnchorButton href={links.cookiePolicy} small={true} className={s.link}>
          <FormattedMessage
            description="Cookie Policy link text"
            defaultMessage="Cookie Policy"
            id="euhaNY"
          />
        </AnchorButton>
      </ButtonGroup>
    </div>
  );
};

export { Footer };
